import { Head } from '../../components/Head'
import { OrderHeader } from '../../components/OrderHeader'
import { Table } from './Table'
import * as Styled from './styles'

export default function MycartPage() {
  return (
    <>
      <Head title='carrinho' description='' />
      <Styled.Container>
        <OrderHeader />
        <Table />
      </Styled.Container>
    </>
  )
}
